import {
  Button,
  Form,
  Row,
  Pagination,
  notification,
  DatePicker,
  message,
} from "antd";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState } from "react";
import locale from "antd/es/date-picker/locale/vi_VN";
import { EStatusTrip } from "../../helpers/const";
import $axios from "../../services/axios";
import _ from "lodash";
import moment from "moment";
import dayjs from "dayjs";
import { getPlaceDetailFromLatLng } from "../../helpers/utils";

const History = ({
  setStep,
  setLoading,
  setDataPlace,
  setDataInputPlace,
  setIsPlaceHistory,
}) => {
  const [form] = Form.useForm();
  const [listHistory, setListHistory] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rangePresets = [
    {
      label: "7 ngày qua",
      value: [dayjs().add(-7, "d"), dayjs()],
    },
    {
      label: "14 ngày qua",
      value: [dayjs().add(-14, "d"), dayjs()],
    },
    {
      label: "30 ngày qua",
      value: [dayjs().add(-30, "d"), dayjs()],
    },
    {
      label: "90 ngày qua",
      value: [dayjs().add(-90, "d"), dayjs()],
    },
  ];

  const onBackToBookCar = async ({ isSwap, booking }) => {
    setLoading(true);
    try {
      const startPlace = await getPlaceDetailFromLatLng(
        booking.startPointX,
        booking.startPointY
      );
      const endPlace = await getPlaceDetailFromLatLng(
        booking.endPointX,
        booking.endPointY
      );
      setIsPlaceHistory(true);
      if (isSwap) {
        setDataInputPlace({
          from: booking.endPointGeocode,
          to: booking.startPointGeocode,
        });
        setDataPlace({
          from: endPlace,
          to: startPlace,
        });
      } else {
        setDataInputPlace({
          from: booking.startPointGeocode,
          to: booking.endPointGeocode,
        });
        setDataPlace({
          from: startPlace,
          to: endPlace,
        });
      }
      setStep("booking");
      setLoading(false);
    } catch (error) {
      message.error("Đã có lỗi xảy ra! Vui lòng thử chuyến đi khác");
      setLoading(false);
    }
  };

  useEffect(() => {
    getListHistory(currentPage, _.get(rangePresets, "[0].value", []));
  }, []);

  const getListHistory = async (page, dateRange) => {
    const startTime = dayjs(dateRange[0]).format("DD/MM/YYYY") + " 00:00:00";
    const endTime = dayjs(dateRange[1]).format("DD/MM/YYYY") + " 00:00:00";
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/api/v1/gsm/transactions/list?startDate=${startTime}&endDate=${endTime}&page=${page}&pageSize=10`
      );
      setListHistory(res.data.data.data);
      setTotal(res.data.data.totalRecordCount);
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };
  const onFinish = async (values) => {
    try {
      await getListHistory(currentPage, values.dateRange);
    } catch (error) {
      notification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };
  return (
    <div className="flex items-center justify-center w-full absolute top-[100px]">
      <div className="flex flex-col gap-2 items-center w-[92%]">
        <h2 className="text-white text-[16px] font-semibold mb-4">
          Lịch sử đặt xe
        </h2>
        <div className="w-full px-5 py-6 rounded-[12px] bg-white">
          <Form
            form={form}
            onFinish={onFinish}
            layout="horizontal"
            initialValues={{
              dateRange: rangePresets[0].value, // Giá trị mặc định cho `dateRange`
            }}
            className="flex items-start gap-2 m-0"
          >
            <Form.Item
              name={"dateRange"}
              rules={[{ required: true, message: "Vui lòng chọn thời gian!" }]}
              className="m-0 flex-1"
            >
              <DatePicker.RangePicker
                popupClassName="ant-picker-no-left"
                presets={rangePresets}
                format="DD/MM/YYYY"
                className="h-10"
                locale={locale}
                suffixIcon={
                  <svg
                    className="text-primary mt-2"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_120_8739)">
                      <path
                        d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_120_8739">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              />
            </Form.Item>

            <Form.Item className="m-0">
              <Button
                type="primary"
                htmlType="submit"
                className="h-10 font-bold"
              >
                Tìm kiếm
              </Button>
            </Form.Item>
          </Form>
          {/* Hotline */}
        </div>
        <div className="text-center my-10">
          <span className="text-white font-normal">
            Hotline hỗ trợ khách hàng{" "}
          </span>
          <a
            href="tel:1900255585"
            className="font-bold text-primary text-[16px]"
          >
            1900255585
          </a>
        </div>
        {listHistory.length > 0 &&
          listHistory.map((item, index) => (
            <div
              key={item.id}
              className="mt-2 w-full p-4 bg-white rounded-[12px] mb-4 "
              style={{
                boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div className="items-start flex gap-1 flex-col">
                <p className="text-[12px]">
                  Mã đơn hàng :{" "}
                  <span className="text-orange-600 text-[10px] font-semibold">
                    {item.orderCode}
                  </span>
                </p>
                <p className="text-[12px]">
                  Điểm đi :{" "}
                  <span className="text-primary text-[12px] font-semibold">
                    {item.startPointGeocode}
                  </span>
                </p>
                <p className="text-[12px]">
                  Điểm đến :{" "}
                  <span className="text-primary text-[12px] font-semibold">
                    {item.endPointGeocode}
                  </span>
                </p>
                <p className="text-[12px]">
                  Thời gian:{" "}
                  <span className="font-bold text-primary text-[12px] ">
                    {moment(item.createdAt).format("DD/MM/YYYY HH:mm")}
                  </span>
                </p>
              </div>
              <hr className="my-2" />
              <Row className="justify-between items-center">
                <div className="flex gap-2 items-center w-1/2">
                  <div className="flex flex-col gap-1">
                    {/* <p className="text-[10px]">
                      Họ và tên :{" "}
                      <span className="text-primary text-[10px] font-semibold">
                        {item.customerFullName}
                      </span>
                    </p> */}
                    <p className="text-[10px]">
                      Tổng tiền :{" "}
                      <span className="text-primary text-[10px] font-semibold">
                        {item.amount.toLocaleString("vi-VN")}
                      </span>
                    </p>
                    <div
                      className={`text-white ${
                        item.paymentStatus === 1
                          ? "bg-green-600"
                          : item.paymentStatus === -3
                          ? "bg-orange-400"
                          : "bg-red-600"
                      } rounded-[20px] px-4 py-1 w-fit text-[10px]`}
                    >
                      {item.paymentStatus === 1
                        ? "Đã thanh toán"
                        : item.paymentStatus === -3
                        ? "Hoàn tiền thành công"
                        : "Lỗi thanh toán"}
                    </div>

                    {item.tripStatus === EStatusTrip.CCANCELLED && (
                      <div
                        className={`text-white  rounded-[20px] px-4 py-1 w-fit text-[10px] bg-red-600`}
                      >
                        Chuyến đi bị huỷ
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-1/2 items-center">
                  <Button
                    size="small"
                    onClick={() =>
                      onBackToBookCar({ isSwap: true, booking: item })
                    }
                    className="w-[120px] bg-gray-400 text-white text-[10px]"
                  >
                    <span className="text-[12px]">Đặt quay về</span>
                  </Button>
                  <Button
                    size="small"
                    onClick={() =>
                      onBackToBookCar({ isSwap: false, booking: item })
                    }
                    className="w-[120px] bg-green-500 text-white text-[10px]"
                  >
                    <span className="text-[12px]">Đặt lại</span>
                  </Button>
                </div>
              </Row>
            </div>
          ))}

        {total > 0 && (
          <Pagination
            current={currentPage}
            className="mt-2"
            total={total}
            onChange={(page) => {
              setCurrentPage(page);
              getListHistory(page, form.getFieldValue("dateRange"));
            }}
            pageSize={10}
            showSizeChanger={false}
            showQuickJumper={false}
          />
        )}

        <div className="w-full mt-4 px-4">
          <div className="flex justify-between">
            <Button
              onClick={() => {
                setStep("booking");
              }}
              type="primary"
              className="w-[45%] h-[45px] rounded-[10px] text-center mx-auto text-[15px]"
            >
              <span className="font-semibold">Trang chủ</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
